module.exports = __webpack_public_path__ + "static/img/programme_resource_management.c7eabb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/programme_resource_management.jpg
// module id = felI
// module chunks = 0